export const ALERTS_DATA = "ALERTS_DATA";
export const ALERTS_ERROR = "ALERTS_ERROR";
export const ALERTS_HIDE_ERROR = "ALERTS_HIDE_ERROR";
export const ALERTS_START_LOADER = "ALERTS_START_LOADER";
export const ALERTS_STOP_LOADER = "ALERTS_STOP_LOADER";
